import styled from 'styled-components';
import { breakpoint, font, grid, GridSpacing } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';

export const Details = styled.div<{ theme: Theme }>`
  background-color: ${getColor('surfaceWhite')};
  font-family: ${font.graphikCond};
  font-size: 14px;
  font-weight: 500;
  letter-spacing: .576px;
  line-height: 21px;
  padding: 4px 16px 16px;
  text-align: left;

  @media (${breakpoint.mdMin}) {
    padding: 4px 24px 0;
    margin: 0 -24px;
  }

  @media (${breakpoint.xlMin}) {
    padding: 4px 16px 0 0;
    margin: 0;
  }
  
  &.full_bleed {
    padding: 4px 16px 16px;
    margin: 0;

    @media (${breakpoint.mdMin}) {
      padding: 4px 24px 16px;
      margin: 0;
    }

    @media (${breakpoint.xlMin}) {
      padding: 4px 24px 16px;
      margin: 0;
    }

    @media (${breakpoint.xxlMin}) {
      padding: 4px 48px 16px;
      margin: 0;
    }
  }
  
  &.portrait {
    padding: 8px 16px 4px;

    @media (${breakpoint.mdMin}) {
      padding: 8px ${grid(1, 2, GridSpacing.md)} 4px;
      margin: 0 calc( 0px - ${grid(1, 2, GridSpacing.md)} );
    }
    
    @media (${breakpoint.xlMin}) {
      padding-left: 0;
      padding-right: 0;
      margin: 0;
    }
  }
`;

export const Credit = styled.div<{ theme: Theme }>`
  color: ${getColor('textSecondary')};
  display: block;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 1px;
  line-height: 18px;
  text-align: left;
  text-transform: uppercase;
`;
